import React, { useEffect } from 'react'
import DialogModal from 'shared/components/DialogModal'
import PropTypes from 'prop-types'
import { Grid, Stack, Typography } from '@mui/material'
import { ButtonContained } from 'shared/components/Button'
import { COLORS, Fonts } from 'shared/constants/AppEnums'
import { useDispatch } from 'react-redux'
import { onGetSurveyDetail } from 'redux/actions'
import { useSelector } from 'react-redux'
import AppLoader from '@crema/core/AppLoader'

const DialogDetail = ({ open, handleClose, id }) => {
    const dispatch = useDispatch()
    const { detail } = useSelector(state => state.survey)
    const { loading } = useSelector(state => state.common)

    useEffect(() => {
        if (open) {
            dispatch(onGetSurveyDetail(id))
        }
    }, [open])

    const renderPertanyaan = (type) => {
        let arr = []
        for (const key in detail?.response) {
            if (type === 'penggunaan' && key.startsWith('Modul')) {
                arr.push(
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant='h5' fontWeight={Fonts.BOLD}>{key}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Stack pl={2}>
                                {
                                    detail?.response[key].map((item, index) => (
                                        <Stack key={index} spacing={2} direction={'row'}>
                                            <Typography variant='h5' fontWeight='500'>-</Typography>
                                            <Typography variant='h5' fontWeight='500'>{item}</Typography>
                                        </Stack>
                                    ))
                                }
                            </Stack>
                        </Grid>
                    </Grid>
                )
            } else if (type === 'penilaian' && !key.startsWith('Modul')) {
                arr.push(
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant='h5' fontWeight={Fonts.BOLD}>{key}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant='h5' fontWeight='500'>{detail?.response[key][0] === 1 ? 'Sangat Tidak Setuju' : detail?.response[key][0] === 2 ? 'Tidak Setuju' : detail?.response[key][0] === 3 ? 'Biasa Saja/Netral' : detail?.response[key][0] === 4 ? 'Setuju' : 'Sangat Setuju'}</Typography>
                        </Grid>
                    </Grid>
                )
            }
        }

        return arr
    }
    return (
        <DialogModal open={open} handleClose={handleClose} size='sm' title={'Detail Survey'}>
            {
                loading && <AppLoader />
            }
            <Stack spacing={6}>
                <Stack spacing={3}>
                    <Stack bgcolor={COLORS.primary} color={'white'} borderRadius={2}>
                        <Typography sx={{ m: 2, fontWeight: 'bold', fontSize: '16px' }}>Data Penggunaan</Typography>
                    </Stack>

                    <Stack spacing={3} pl={4}>
                        {renderPertanyaan('penggunaan')}
                    </Stack>
                </Stack>

                <Stack spacing={3}>
                    <Stack bgcolor={COLORS.primary} color={'white'} borderRadius={2}>
                        <Typography sx={{ m: 2, fontWeight: 'bold', fontSize: '16px' }}>Data Penilaian</Typography>
                    </Stack>

                    <Stack spacing={3} pl={4}>
                        {renderPertanyaan('penilaian')}
                    </Stack>
                </Stack>
            </Stack>
        </DialogModal>
    )
}

DialogDetail.propTypes = {
    open: PropTypes.bool,
    id: PropTypes.string,
    handleClose: PropTypes.func,
}

export default DialogDetail
